<span>
  <label *ngIf="props.altLabel" [for]="field.id">{{ props.altLabel }}</label>
  <p-calendar
    [maxDate]="props.maxDate ? props.maxDate : null"
    [minDate]="props.minDate ? props.minDate : null"
    [selectionMode]="props.selectionMode ?? 'single'"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [placeholder]="props.placeholder"
    [view]="props.view ? props.view : 'date'"
    [dateFormat]="props.dateFormat"
    [readonlyInput]="props.readonly"
    [showOnFocus]="!props.readonly"
    [appendTo]="props.appendTo ?? 'body'"
    [id]="field.id"
  ></p-calendar>
</span>
